import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M17.51 3.87L15.73 2.1 5.84 12l9.9 9.9 1.77-1.77L9.38 12l8.13-8.13z"
}), 'ArrowBackIosTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/ArrowBackIosTwoTone.js
// module id = 2073
// module chunks = 2